// Smoothly scrolls to an element on the same page, respecting reduced-motion settings.
export const scrollToId = (id: string): void => {
    const target = document.getElementById(id)

    if (!target) return

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' })
    window.history.replaceState(window.history.state, '', `#${id}`)
}
